import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "@App/state";
import { bindActionCreators } from "@reduxjs/toolkit";
import { PremiumService } from "@App/types";
import { PremiumServiceIsReplacementOrPickup } from "@App/utils/conditionals/premiumServices";

export const usePremiumServiceUtils = () => {
  const premiumServices = useSelector((state: State) => state.orders.premiumServices);

  const dispatch = useDispatch();
  const { addPremiumService, removePremiumService, chooseSlot } = bindActionCreators(
    actionCreators,
    dispatch,
  );

  const togglePremiumService = (premiumService: PremiumService) => {
    // try to find the service to remove it from the list if already checked
    let exists = premiumServices.some((p) => p.type === premiumService.type);

    if (exists) {
      removePremiumService(premiumService);
      return;
    }

    // add the premium service to the list if nothing found
    addPremiumService(premiumService);
  };

  const toggleSingularPremiumService = (premiumService: PremiumService) => {
    // try to find the service to remove it from the list if already checked
    let exists = premiumServices.some((p) => p.type === premiumService.type);

    if (exists) {
      removePremiumService(premiumService);
      return;
    }
    premiumServices.forEach((premiumService): void => {
      removePremiumService(premiumService);
    });

    addPremiumService(premiumService);
  };

  const togglePremiumServiceCarReplacementOrPickup = (premiumService: PremiumService) => {
    // try to find the service to remove it from the list if already checked
    let exists = premiumServices.some((p) => p.type === premiumService.type);

    // null the slot as toggling these premium services can change the slot availability
    chooseSlot(null);

    premiumServices.forEach((premiumService): void => {
      if (PremiumServiceIsReplacementOrPickup(premiumService)) {
        removePremiumService(premiumService);
      }
    });

    if (exists) {
      removePremiumService(premiumService);
      return;
    }

    // add the premium service to the list if nothing found
    addPremiumService(premiumService);
  };

  const toggled = (premiumService: PremiumService): boolean => {
    return premiumServices.some((p) => p.type === premiumService.type);
  };

  return {
    toggled,
    togglePremiumServiceCarReplacementOrPickup,
    togglePremiumService,
    toggleSingularPremiumService,
  };
};
